import axios from 'axios'
import Cookies from 'js-cookie'

import store from "@/store"

import SETTINGS from '@/plugins/settings'

import auth from './auth'
import category from './category'
import collection from './collection'
import issue from './issue'
import library from './library'

const apiConfig = {
	url: SETTINGS.BACKEND_URL,
	namespace: 'api',
	version: 'v1'
}

const client = axios.create({
  baseURL: apiConfig.url,
  withCredentials: true, // required to handle the CSRF token
})

const API = {

	/**
	 * Modules.
	 */
	auth,
	category,
	collection,
	issue,
	library,
	
	client()
	{
		return client
	},

	getUrl(endpoint, api=true)
	{
		if( api )
			return `${apiConfig.namespace}/${apiConfig.version}/${endpoint}/`

		return endpoint
	},

	async interceptor(config)
	{
		let checkMethod = (
					config.method == 'post' || 
					config.method == 'put' || 
					config.method == 'delete'
				),
				token = Cookies.get('XSRF-TOKEN')

		if ( checkMethod && !token ){
			await axios.get(`${apiConfig.url}sanctum/csrf-cookie`)
						.then(()=> config)
		}

		return config
	},

	setBearer(config)
	{
		let token = store.getters['auth/apiToken']

		if(token)
			config.headers.Authorization = `Bearer ${token}`

		return config
	},

	cancelToken()
	{
		const CancelToken = axios.CancelToken,
					source = CancelToken.source()

		return source
	},

	isCancel(err)
	{
		return axios.isCancel(err)
	}

}

client.defaults.headers.post['Content-Type'] ='application/json'
client.defaults.headers.post['Accept'] ='application/json'

//client.interceptors.request.use(API.interceptor, null)
client.interceptors.request.use(API.setBearer, null)
//client.interceptors.request.use((config)=>{ console.log(config); return config }, null)

/*
client.interceptors.response.use(
  (response) => {
    return response;
  },
  function(error) {
    if (
      error.response
      && [401, 419].includes(error.response.status)
      //&& store.getters["auth/user"]
    ) {
      store.dispatch("auth/logout")
    }
    return Promise.reject(error.response)
  }
)
*/
export default API